import React, { useEffect, useState } from "react";
import { successNotify, errorNotify } from "../../../Services/Notification";
import CorporateActionTable from "./CorporateActionMasterTable";
import CorporateeActionMasterAdd from "./CorporateeActionMasterAdd";
import CorporateActionMasterEdit from "./CorporateActionMasterEdit";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import MasterDropDown from "../../../components/corporateAction/corpMaster/MasterDropDown";
import CorporateActionMasterImport from "./CorporateActionMasterImport";
import { handleGetOneData } from "../../../utils/handleGetOneData";
import axios from "axios";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";
const addCorpActionMaster = `${process.env.REACT_APP_API_URL}api/add-corporate-action`;
const editCorpActionMaster = `${process.env.REACT_APP_API_URL}api/edit-corporate-action`;

const getMaster = `${process.env.REACT_APP_API_URL}api/get-corporate-action-master`;
const importCorpActionMaster = `${process.env.REACT_APP_API_URL}api/import-corporate-action`;
const deleteCorpActionMaster = `${process.env.REACT_APP_API_URL}api/corpaction`;
const autoCorpActionApproval = `${process.env.REACT_APP_API_URL}api/trigger-corporate-action-auto-approval`;
const CorporateActionMaster = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [filterData, setFilterData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isImport, setIsImport] = useState(false);
  const [isMessage, setIsMessage] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [globalFilters, setGlobalFilters] = React.useState();
  const [filterCorpData, setFilterCorpData] = React.useState();
  const [scriptNames, setScriptNames] = useState([]);
  const [hasStoredScriptNames, setHasStoredScriptNames] = useState(false);
  const [rowData, setRowData] = useState();
  const [rejectedId, setRejectedId] = useState([]);
  const [secScripId, setSecScripIds] = useState([]);
  const [corpActionData, setCorpActionData] = useState();
  const [isFilter, setIsFilter] = useState();
  const [scripData, setScripData] = useState([]);
  const [dataFetching, setDataFetching] = useState();
  const [isButtonClicked, setIsButtonClicked] = useState();
  const [isDownloadClicked, setIsDownloadClicked] = useState();
  const [isApproveClicked, setIsApproveClicked] = useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const [corpData, setCorpData] = useState([]);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const subscriberData = JSON.parse(sessionStorage.getItem("SubscriberData"));

  const userName = subscriberData
    ? subscriberData?.first_name + " " + subscriberData?.last_name
    : user?.first_name + " " + user?.last_name;

  const finYearId =
    sessionStorage.getItem("finYearID") &&
    Number(sessionStorage.getItem("finYearID"));

  const getCorporateMaster = async () => {
    try {
      if (finYearId) {
        setIsLoading(true);
        const res = await axios.post(
          getMaster,
          { fin_year: finYearId },
          { headers },
        );
        if (res?.data?.data) {
          let data = res?.data?.data
            ?.map((item) => ({
              ...item,
              status: item.status ? "Active" : "Inactive",
            }))
            ?.sort(
              (a, b) =>
                new Date(b.bookclose_recorddate) -
                new Date(a.bookclose_recorddate),
            );
          const scrips = data?.map((item) => item.script_name);
          const uniqueValues = Array.from(new Set(scrips));
          setScripData(uniqueValues);
          setDataFetching("fetched");
          setCorpActionData(data);
          setIsLoading(false);
        } else {
          setCorpActionData(null);
          setIsLoading(false);
          setDataFetching("fetched");
        }
        return res;
      }
    } catch (error) {
      setIsLoading(false);
      setDataFetching(false);
      return error;
    }
  };

  useEffect(() => {
    setDataFetching("fetching");
    getCorporateMaster();
  }, [finYearId, renderKey]);

  const userID = user?.userId;
  const handleCorpData = async () => {
    if (corpActionData) {
      let filter = corpActionData;
      if (filterData) {
        if (filterData.script_name) {
          filter = filter.filter((item) =>
            item.script_name?.includes(filterData.script_name),
          );
        }

        if (filterData.corporate_action) {
          filter = filter.filter(
            (item) => item.corpaction_tag === filterData.corporate_action,
          );
        }
        if (filterData.caa_status) {
          if (filterData.caa_status === "S") {
            filter = filter.filter(
              (item) => item.caa_status === "A" && item.addl_status === "S",
            );
          }
          if (filterData.caa_status === "A") {
            filter = filter.filter(
              (item) =>
                (item.caa_status === "A" && item.addl_status === null) ||
                (item.caa_status === "A" && item.addl_status === "F"),
            );
          }

          if (filterData.caa_status === "P") {
            filter = filter.filter(
              (item) => item.caa_status === "P" && item.addl_status === null,
            );
          }
          if (filterData.caa_status === "O") {
            filter = filter.filter(
              (item) => item.caa_status === "P" && item.addl_status === "O",
            );
          }
        }

        if (filterData.ex_from && filterData.ex_to) {
          filter = filter.filter(
            (item) =>
              item.bookclose_recorddate >= filterData.ex_from &&
              item.bookclose_recorddate <= filterData.ex_to,
          );
        } else if (filterData.ex_from) {
          filter = filter.filter(
            (item) => item.bookclose_recorddate >= filterData.ex_from,
          );
        } else if (filterData.ex_to) {
          filter = filter.filter(
            (item) => item.bookclose_recorddate <= filterData.ex_to,
          );
        }
      }

      setCorpData(filter);
    }
  };

  useEffect(() => {
    handleCorpData();
  }, [filterData, corpActionData]);

  const groupedData =
    corpData &&
    corpData.reduce((acc, item) => {
      let key;
      if (item.corpaction_tag === "X") {
        key = `${item.inputile_id}-${item.corpaction_tag}-${item.company_name}`;
      } else {
        key = `${item.inputile_id}-${item.corpaction_tag}`;
      }

      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

  const processedData =
    groupedData &&
    Object.values(groupedData).map((group) => {
      const sortedGroup = group.sort((a, b) => b.id - a.id);
      let mainItem = sortedGroup.find((item) => item.caa_status === "A");

      if (!mainItem) {
        mainItem = sortedGroup[0];
      }

      if (mainItem) {
        mainItem.childs = sortedGroup
          .map((child) => {
            const { childs, ...childWithoutChilds } = child;
            return childWithoutChilds;
          })
          .sort((a, b) => a.id - b.id);
        return mainItem;
      }
    });

  const data = processedData;

  // process all
  const handleapplyCorporate = async (data) => {
    const postData = {
      ca_eligibility_data: data,
    };
    try {
      const res = await axios.post(addCorpActionMaster, postData, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify(resData?.message);
      }
    } catch (err) {
      return false;
    }
  };

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data?.filter(
        (item) =>
          item?.inputile_id
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.script_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.face_value
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.action_code
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.multiplier
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.remarks?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.script_sec_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.price?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setFilterCorpData(filterData);
  };

  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddCorpAction = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(addCorpActionMaster, data, { headers });
      const resData = res.data;
      if (resData.error) {
        errorNotify(resData.message);
        setIsButtonClicked(false);
      } else {
        successNotify(resData.message);
        setIsButtonClicked(false);
        window.location.reload();
        triggerRerender();
        return true;
      }
    } catch (err) {
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditCorpAction = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${editCorpActionMaster}`;
    try {
      const res = await axios.post(updateAPI, data, { headers });
      const resData = res.data;
      if (resData.error) {
        errorNotify(resData.message);
        setIsButtonClicked(false);
      } else {
        successNotify(resData.message);
        setIsButtonClicked(false);
        triggerRerender();
        window.location.reload();
        return true;
      }
    } catch (err) {
      setIsButtonClicked(false);
      console.log(err);
      errorNotify("Something went wrong");
      return false;
    }
  };

  // import
  const handleImportCorpAction = async (data) => {
    setIsButtonClicked(true);
    const updateAPI = `${importCorpActionMaster}`;

    try {
      const res = await axios.post(updateAPI, data);
      const resData = res.data;
      if (resData.error) {
        errorNotify(resData.message);
        setIsButtonClicked(false);
      } else {
        successNotify(resData.message);
        setIsButtonClicked(false);
        triggerRerender();
        window.location.reload();
        return true;
      }
    } catch (err) {
      setIsButtonClicked(false);
      return false;
    }
  };

  useEffect(() => {
    if (isMessage === "Something went wrong") {
      errorNotify(isMessage);
    } else {
      successNotify(isMessage);
    }
  }, [isMessage]);

  // DELETE

  const handleDeleteCorpAction = async (segmentId) => {
    const Segmentdata = handleGetOneData(corpData, selectedItemId);
    const updatedStatus = Segmentdata.status === "Active" ? true : false;

    const updatedObject = {
      ...Segmentdata,
      status: updatedStatus,
      action_code: "C",
    };
    const deleteAPI = `${deleteCorpActionMaster}/${selectedItemId}`;

    try {
      const res = await axios.delete(deleteAPI, {
        headers,
        data: updatedObject,
      });
      const resData = res.data;

      if (resData.error) {
        errorNotify(resData.message);
      } else {
        successNotify(resData.message);
        window.location.reload();
        triggerRerender();
      }
      triggerRerender();
      setIsDelete(false);
      if (!resData.error) return true;
    } catch (err) {
      console.error(err);
      setIsDelete(false);
      return false;
    }
  };

  const handleAutoApproval = async () => {
    setIsApproveClicked(true);
    try {
      const res = await axios.post(autoCorpActionApproval, null, {
        headers,
      });
      const resData = res.data;
      if (resData.error) {
        errorNotify(resData.message);
      } else {
        successNotify(resData.message);
        triggerRerender();
      }
      triggerRerender();
      if (!resData.error) return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setIsApproveClicked(false);
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  // download
  const downloadExcel = async () => {
    setIsDownloadClicked(true);
    const downloadUrl = `${process.env.REACT_APP_API_URL}api/download-corporate-action-master`;
    try {
      const apiEndpoint = downloadUrl;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${userName} Corporate-Action-Master_${formattedDate}.xlsx`;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsDownloadClicked(false);
    }
  };

  const breadcrumbs = ["Home", "Master", "Corporate Action"];

  const buttonConfig = {
    value: "corp-action",
    name: "Corp. Action",
    // getOneHandler: getCorporateAction,
    addHandler: handleAddCorpAction,
    editHandler: handleEditCorpAction,
    deleteHandler: handleDeleteCorpAction,
    downloadHandler: downloadExcel,
    handleapplyCorporate: handleapplyCorporate,
    autoApprovalHandler: handleAutoApproval,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
    closeImportModel: () => setIsImport(false),
  };

  useEffect(() => {
    if (data?.length > 0 && !hasStoredScriptNames) {
      const unique = {};
      const uniqueData = data?.filter((item) => {
        const key = item?.script_name;
        if (!unique[key]) {
          unique[key] = true;
          return true;
        }
        return false;
      });
      const scriptNames = data && uniqueData?.map((item) => item?.script_name);
      setScriptNames(scriptNames);
      setHasStoredScriptNames(true);
    }
  }, [data, hasStoredScriptNames]);

  if (data === undefined) return null;

  return (
    <>
      <div className=" app-container min-h-[65vh]  pb-[60px] pt-[100px]">
        <Breadcrumbs items={breadcrumbs} />

        <MasterDropDown
          scriptNames={scriptNames}
          setFilterData={setFilterData}
          setIsFilter={setIsFilter}
          isFilter={isFilter}
          scrip={scripData}
          dataFetching={dataFetching}
        />

        <CorporateActionTable
          isLoading={isLoading}
          tableData={globalFilters ? filterCorpData : data}
          buttonConfig={buttonConfig}
          setIsAdd={setIsAdd}
          setIsEdit={setIsEdit}
          setIsDelete={setIsDelete}
          setIsImport={setIsImport}
          setSelectedItemId={setSelectedItemId}
          renderKey={renderKey}
          setRenderKey={setRenderKey}
          setGlobalFilters={setGlobalFilters}
          actionPermissions={actionPermissions("masters", "Corporate Action")}
          setRowData={setRowData}
          setRejectedId={setRejectedId}
          setSecScripIds={setSecScripIds}
          setIsFilter={setIsFilter}
          isFilter={isFilter}
          isDownloadClicked={isDownloadClicked}
          isApproveClicked={isApproveClicked}
        />

        {isAdd && (
          <CorporateeActionMasterAdd
            buttonConfig={buttonConfig}
            renderKey={renderKey}
            isButtonClicked={isButtonClicked}
          />
        )}

        {isImport && (
          <CorporateActionMasterImport
            handleImportCorpAction={handleImportCorpAction}
            renderKey={renderKey}
            buttonConfig={buttonConfig}
            isButtonClicked={isButtonClicked}
          />
        )}

        {isEdit && (
          <CorporateActionMasterEdit
            buttonConfig={buttonConfig}
            selectedItemId={selectedItemId}
            rowData={rowData}
            userID={userID}
            rejectedId={rejectedId}
            isButtonClicked={isButtonClicked}
          />
        )}
      </div>
    </>
  );
};

export default CorporateActionMaster;
